if (!customElements.get('product-usps')) {
  class ProductUsps extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener('click', this.onUspClick.bind(this), { signal });
      document.addEventListener('click', this.onBackClick.bind(this), { signal });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onEditorBlockSelect.bind(this), { signal });
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    get scrollBehavior() {
      return this.prefersReducedMotion ? 'auto' : 'smooth';
    }

    findAccordion(anchor) {
      const scope = this.closest('.product__info-container') || document;
      const selector = `details[data-usp-anchor="${CSS.escape(anchor)}"]`;
      return scope.querySelector(selector) || document.querySelector(selector);
    }

    onUspClick(event) {
      const trigger = event.target.closest('[data-usp-accordion]');
      if (!trigger) return;

      const accordion = this.findAccordion(trigger.dataset.uspAccordion);
      if (!accordion) return;

      event.preventDefault();
      this.revealAccordion(accordion);
    }

    async revealAccordion(accordion) {
      if (!accordion.open) {
        accordion.open = true;
        // Opening collapses sibling accordions, so wait for the layout to settle before scrolling.
        await new Promise((resolve) => setTimeout(resolve, this.prefersReducedMotion ? 0 : 320));
      }

      const backButton = accordion.querySelector('[data-usp-back]');
      if (backButton) {
        if (this.dataset.backLabel) backButton.querySelector('[data-usp-back-label]').textContent = this.dataset.backLabel;
        backButton.hidden = false;
      }

      accordion.scrollIntoView({ behavior: this.scrollBehavior, block: 'start' });
      accordion.querySelector('summary')?.focus({ preventScroll: true });
    }

    onBackClick(event) {
      const backButton = event.target.closest('[data-usp-back]');
      if (!backButton) return;

      event.preventDefault();
      window.scrollTo({ top: 0, behavior: this.scrollBehavior });
      this.querySelector('.product-usps__card')?.focus({ preventScroll: true });
    }

    onEditorBlockSelect(event) {
      const store = event.target.closest?.('.product-usps-store');
      if (!store) return;

      const drawer = store.closest('basic-modal');
      if (!drawer || !this.querySelector(`[aria-controls="${drawer.id}"]`)) return;

      drawer.show();
      store.open = true;
    }
  }

  customElements.define('product-usps', ProductUsps);
}
